import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { WarningModalPage } from '../page/warning-modal/warning-modal.page';

import { AuthService } from './auth.service';
import { ApiService } from './api.service';
import { LogService } from './log.service';

@Injectable({
    providedIn: 'root'
})
export class WarningService
{
    private modal = null;

    constructor(
        private modalCtrl: ModalController,
        private auth: AuthService,
        private api: ApiService,
        private log: LogService
    )
    {
    }

    async register()
    {
        if (await this.auth.isAuth() === false) return;

        this.subscriber();
    }

    async subscriber()
    {
        const resp: any = await this.api.getwarning();

        if (resp.warning == 1) {
            this.openModal(resp.title, resp.text);
        }
    }

    async openModal(title, message)
    {
        if (!this.auth.empty(this.modal)) {
            return;
        }

        this.modal = await this.modalCtrl.create({
            component: WarningModalPage,
            id: 'warning-modal',
            backdropDismiss: false,
            cssClass: 'warning-modal',
            mode: 'ios',
            componentProps: { title: title, message: message }
        });

        this.modal.onDidDismiss().then((ret) => {
            this.modal = null;
        });

        await this.modal.present();
    }
}
